var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"snowCanvas",attrs:{"width":_vm.canvasWidth,"height":_vm.canvasHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }